// extracted by mini-css-extract-plugin
export default {"container":"Carrito_container__f8pkO","body":"Carrito_body__itLZU","tuyo":"Carrito_tuyo__9VfAv","cajasnegras":"Carrito_cajasnegras__9iKYB"};